export default __webpack_public_path__ + "static/media/fpa60000.5b81f011.png";